var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEventCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3584 20.0399L20.0384 18.3599L15.5984 13.9199V8.3999H13.1984V14.8799L18.3584 20.0399ZM14.3984 26.3999C12.7384 26.3999 11.1784 26.0849 9.71844 25.4549C8.25844 24.8249 6.98844 23.9699 5.90844 22.8899C4.82844 21.8099 3.97344 20.5399 3.34344 19.0799C2.71344 17.6199 2.39844 16.0599 2.39844 14.3999C2.39844 12.7399 2.71344 11.1799 3.34344 9.7199C3.97344 8.2599 4.82844 6.9899 5.90844 5.9099C6.98844 4.8299 8.25844 3.9749 9.71844 3.3449C11.1784 2.7149 12.7384 2.3999 14.3984 2.3999C16.0584 2.3999 17.6184 2.7149 19.0784 3.3449C20.5384 3.9749 21.8084 4.8299 22.8884 5.9099C23.9684 6.9899 24.8234 8.2599 25.4534 9.7199C26.0834 11.1799 26.3984 12.7399 26.3984 14.3999C26.3984 16.0599 26.0834 17.6199 25.4534 19.0799C24.8234 20.5399 23.9684 21.8099 22.8884 22.8899C21.8084 23.9699 20.5384 24.8249 19.0784 25.4549C17.6184 26.0849 16.0584 26.3999 14.3984 26.3999Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventCheckIcon);
export default __webpack_public_path__ + "static/media/EventCheckIcon.544e008de2a43010183945432b571ecb.svg";
export { ForwardRef as ReactComponent };